import { StationeryTemplateCategoryEnum } from '@graphql/generated-base';

// Image URLs shown as supplementary slides on both the PDP preview pane and gallery tile carousel.
// Single source of truth — update here and both consumers stay in sync.

export const PDP_SUPPLEMENTARY_URLS = {
  // Digital
  DIGITAL_CARD_EDITOR: 'https://withjoy.com/assets/public/card-editor-preview.jpg',
  DIGITAL_SMS_DELIVERY: 'https://withjoy.com/assets/public/text-delivery-preview.jpg',
  // Taylor — card backs
  BACK_THANK_YOU: 'https://withjoy.com/assets/public/back-variety-preview-thankyoucard-2.jpg',
  BACK_HOLIDAY: 'https://withjoy.com/media/print/back-variety-preview-holiday.jpg',
  BACK_SAVE_DATE_INVITATION_ENCLOSURE: 'https://withjoy.com/assets/public/back-variety-preview-5.jpg',
  // Taylor — envelopes & addressing
  ENVELOPES_COMMON: 'https://withjoy.com/assets/public/card-pdp-envelopes.jpg',
  ENVELOPE_THANK_YOU: 'https://withjoy.com/assets/public/envelope-variety-preview-thankyoucard-2.jpg',
  ENVELOPE_HOLIDAY: 'https://withjoy.com/media/print/envelope-variety-preview-holiday.jpg',
  ENVELOPE_SAVE_DATE_INVITATION: 'https://withjoy.com/assets/public/envelope-variety-preview-4.jpg',
} as const;

// Returns the ordered supplementary image URLs for a given category + vendor.
// Used by the gallery tile carousel (direct URL access) and the PDP preview pane (via useCardPreviewPaneAssets).
export const getSupplementaryImages = (category: StationeryTemplateCategoryEnum, vendor: 'taylor' | 'joy_digital'): readonly string[] => {
  const u = PDP_SUPPLEMENTARY_URLS;
  if (vendor === 'joy_digital') return [u.DIGITAL_CARD_EDITOR, u.DIGITAL_SMS_DELIVERY];

  switch (category) {
    case StationeryTemplateCategoryEnum.thankYou:
      return [u.BACK_THANK_YOU, u.ENVELOPES_COMMON, u.ENVELOPE_THANK_YOU];
    case StationeryTemplateCategoryEnum.holiday:
      return [u.BACK_HOLIDAY, u.ENVELOPES_COMMON, u.ENVELOPE_HOLIDAY];
    case StationeryTemplateCategoryEnum.saveTheDate:
    case StationeryTemplateCategoryEnum.invitation:
      return [u.BACK_SAVE_DATE_INVITATION_ENCLOSURE, u.ENVELOPES_COMMON, u.ENVELOPE_SAVE_DATE_INVITATION];
    case StationeryTemplateCategoryEnum.enclosure:
      return [u.BACK_SAVE_DATE_INVITATION_ENCLOSURE];
    default:
      return [];
  }
};
